import { Injectable, inject, signal, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface User {
  id: string;
  email: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly platformId = inject(PLATFORM_ID);
  
  private readonly currentUserSignal = signal<User | null>(null);
  readonly currentUser = this.currentUserSignal.asReadonly();

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const savedUser = localStorage.getItem('regency_user');
      if (savedUser) {
        this.currentUserSignal.set(JSON.parse(savedUser));
      }
    }
  }

  register(data: any): Observable<any> {
    return this.http.post<any>(`${environment.apiBaseUrl}/api/auth/register`, data).pipe(
      tap(res => this.handleAuth(res))
    );
  }

  login(credentials: any): Observable<any> {
    return this.http.post<any>(`${environment.apiBaseUrl}/api/auth/login`, credentials).pipe(
      tap(res => this.handleAuth(res))
    );
  }

  forgotPassword(email: string): Observable<any> {
    return this.http.post<any>(`${environment.apiBaseUrl}/api/auth/forgot-password`, { email });
  }

  logout(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('regency_token');
      localStorage.removeItem('regency_user');
    }
    this.currentUserSignal.set(null);
  }

  getToken(): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('regency_token');
    }
    return null;
  }

  isAuthenticated(): boolean {
    return !!this.currentUserSignal();
  }

  private handleAuth(res: any): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('regency_token', res.token);
      localStorage.setItem('regency_user', JSON.stringify(res.user));
    }
    this.currentUserSignal.set(res.user);
  }
}
